export default __webpack_public_path__ + "static/media/img_16.10c1aad4.JPG";